import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionData from './GetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionData';
import postOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionData from './PostOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const OmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionData = {
  INITIAL_STATE, getOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionData, postOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionData
}

export default OmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionData;